import ApiClient from 'clients/api_client'
import Pagination from 'entities/pagination'
import Recruiter, { RecruiterWithMetrics } from 'entities/recruiter'
import RecruiterInvitationDetail from 'entities/recruiter_invitation_detail'

export default class RecruiterClient {
  static searchIntroducers(keyword, companyToken, offerToken, groupToken) {
    const url = Routes.searchOffersIntroducersPath(companyToken, offerToken, groupToken)
    const params = { keywords: keyword }

    return ApiClient.post(url, params).then(({ data }) => data.map(json => new Recruiter(json)))
  }

  static searchRecruiterWithMetrics(name, order, groupIds, tagIds, appInstalled, status, page) {
    const url = Routes.searchRecruiterWithMetricsPath()
    const params = {
      name,
      order,
      group_ids: groupIds,
      tag_ids: tagIds,
      app_installed: appInstalled,
      status,
      page
    }

    return ApiClient.post(url, params).then(({ data, headers }) => {
      const recruiters = data.map(json => new RecruiterWithMetrics(json))
      const pagination = Pagination.fromJsonLowerCased(headers)

      return {
        recruiters,
        pagination
      }
    })
  }

  static search(keyword) {
    const url = Routes.searchRecruitersPath()
    const params = { keywords: keyword }

    return ApiClient.post(url, params).then(({ data }) => data.map(json => new Recruiter(json)))
  }

  static getRecruterInvitationDetails(id) {
    const url = Routes.recruiterInvitationDetailsPath(id)
    return ApiClient.get(url).then(({ data }) => data.map(json => new RecruiterInvitationDetail(json)))
  }

  static searchForRecruiter(keyword, companyToken, groupToken) {
    const url = Routes.searchForRecruiterRecruitersPath(companyToken, groupToken)
    const params = {
      keywords: keyword
    }

    return ApiClient.post(url, params).then(({ data }) => data.map(json => new Recruiter(json)))
  }
}
